<div class="button-toggle-container">
  <span class="mat-caption">{{ labelT | translate }}</span>
  <mat-button-toggle-group [formControlName]="controlKey" class="language-toggle">
    <mat-button-toggle value="German">
      {{ 'language.german' | translate }}
    </mat-button-toggle>
    <mat-button-toggle value="English">
      {{ 'language.english' | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>